import { render, staticRenderFns } from "./EditTemplateModal.vue?vue&type=template&id=8b923566&"
import script from "./EditTemplateModal.vue?vue&type=script&lang=ts&"
export * from "./EditTemplateModal.vue?vue&type=script&lang=ts&"
import style0 from "./EditTemplateModal.vue?vue&type=style&index=0&id=8b923566&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports